import TimeQuestion from './TimeQuestion';
import NumberQuestion from './NumberQuestion';
import MatrixQuestion from './MatrixQuestion';
import MultiItemTableQuestion from './MultiItemTableQuestion';
import DropdownQuestion from './DropdownQuestion';
import RadioGroupQuestion from './RadioGroupQuestion';
import TextareaQuestion from './TextareaQuestion';

const QuestionRenderer = ({ question, questionNumber, answerOptions, onAnswerChange, answer }) => {
  let Component = null;
  switch (question.type) {
    case "time":
      Component = TimeQuestion;
      break;
    case "number":
      Component = NumberQuestion;
      break;
    case "matrix":
      Component = MatrixQuestion;
      break;
    case "multiItemTable":
      Component = MultiItemTableQuestion;
      break;
    case "textarea":
      Component = TextareaQuestion;
      break;
    default:
      const useDropdown = answerOptions.length > 5;
      Component = useDropdown ? DropdownQuestion : RadioGroupQuestion;
      break;
  }

  return (
    <Component
      question={question}
      questionNumber={questionNumber}
      answerOptions={answerOptions}
      onAnswerChange={onAnswerChange}
      answer={answer}
    />
  );
};

export default QuestionRenderer;